
const PanelContent = {
  baseStyle: {
    ms: "auto",
    me: "auto",
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
